import type { ReactNode } from 'react';
import React from 'react';

type DropDownMenuProps = {
	active: boolean;
	children: ReactNode;
	header: ReactNode;
	className?: string;
	navItemClassName?: string;
	onToggle?: () => void;
};

export default function DropDownMenu(props: DropDownMenuProps) {
	const { active, children, header, className, onToggle, navItemClassName } = props;

	return (
		<div className={`dropdown-container ${className ?? ''}`}>
			<div className={`nav-item ${navItemClassName ?? ''}`} onClick={() => onToggle?.()}>
				{header}
			</div>
			<div className="dropdown">
				<div className={`drop-menu ${active ? 'active' : ''}`}>
					<div className="dropdown-content">{children}</div>
				</div>
			</div>
		</div>
	);
}
